import React from 'react';
import { motion } from 'framer-motion';
import { SectionLabel } from './SectionLabel';
const ABOUT_IMG = 'https://cdn.magicpatterns.com/patterns/generated-images/1b0ca2c3-aea5-4a27-bd89-46874eeb4934.jpg';
export function About() {
  return <section id="quienes-somos" className="w-full bg-vm-cream py-28 lg:py-36" data-id="element-12" data-mp="2trr0m5720jls">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-13" data-mp="2ysy8e4975isg">
        <div className="grid items-center gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(220px,0.38fr)] lg:gap-20" data-id="element-14" data-mp="33rhwobb9j6nz">
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.6
        }} className="order-1" data-id="element-15" data-mp="38pt5ciptnb4m">
            <SectionLabel data-id="element-16" data-mp="3hkr2k2005a1r">Quiénes somos</SectionLabel>
            <h2 className="mt-6 max-w-3xl font-syne text-4xl font-bold leading-[1.03] text-vm-bg sm:text-5xl lg:text-[56px]" data-id="element-17" data-mp="3miiw10gap482">
              Tecnología visual para proyectos que necesitan ser vistos.
            </h2>
            <p className="mt-7 max-w-2xl text-lg font-light leading-relaxed text-vm-navy" data-id="element-18" data-mp="2ls0dybbmr95s">
              Somos un equipo de producción audiovisual que integra pantallas LED, streaming, fotografía y diseño para crear experiencias claras, actuales y memorables.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.97
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.7
        }} className="order-2 mx-auto w-full max-w-[320px] lg:justify-self-end" data-id="element-19" data-mp="27sra8b4m27ip">
            <div className="relative overflow-hidden rounded-2xl" data-id="element-20" data-mp="2vnk9gwma85u0">
              <img src={ABOUT_IMG} alt="Director de fotografía operando una cámara de cine en un estudio de producción" className="aspect-[4/5] h-full w-full object-cover" data-id="element-21" data-mp="2qr3ilunp7dd8" />
              <div className="absolute inset-0 ring-1 ring-inset ring-vm-bg/20" data-id="element-22" data-mp="3jdodh53du7lj" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}